/**
 * Warehouse Help Content
 * 
 * Feature: 136-dashboard-alignment (T049)
 * Pages: /warehouses, /warehouses/catalog
 * Constitution: v1.12.0
 */

import type { PageHelpContent } from '../../components/ui/PageHelpPanel';

export const warehouseHelp: PageHelpContent = {
  pageTitle: 'Warehouses',
  purpose: 'Manage and monitor Fabric SQL Warehouses, including schema object counts and performance metrics.',
  sections: [
    {
      title: 'Overview',
      paragraphs: [
        'Warehouses in Microsoft Fabric provide a T-SQL-based analytical data warehouse experience. This page shows discovered warehouses with their schema details and operational status.',
      ],
    },
    {
      title: 'Key Concepts',
      concepts: [
        { term: 'Warehouse', definition: 'A Fabric item that provides a T-SQL endpoint for analytical queries, supporting tables, views, and stored procedures.' },
        { term: 'Schema Objects', definition: 'Tables, views, stored procedures, and functions discovered in the warehouse. Tracked for inventory completeness.' },
        { term: 'Performance Metrics', definition: 'Query execution times, resource usage, and connection counts for the warehouse endpoint.' },
      ],
    },
    {
      title: 'Catalog View',
      paragraphs: [
        'Browse all warehouses organized by workspace, capacity, or client. Use the catalog to discover warehouses and review their schema object inventory.',
      ],
    },
    {
      title: 'How To',
      steps: [
        { step: 1, instruction: 'Browse the Warehouses list to see all discovered warehouses with their schema object counts and operational status.' },
        { step: 2, instruction: 'Click a warehouse row to inspect its schema details including tables, views, stored procedures, and functions.' },
        { step: 3, instruction: 'Switch to the Catalog view to browse warehouses organized by workspace, capacity, or client.' },
        { step: 4, instruction: 'Review storage and performance metrics on the warehouse detail page to identify optimization opportunities.' },
      ],
    },
    {
      title: 'Related Pages',
      links: [
        { label: 'Lakehouses', href: '/lakehouses' },
        { label: 'Workspaces', href: '/workspaces' },
        { label: 'Backup Runs', href: '/backup' },
      ],
    },
  ],
};

export default warehouseHelp;
